var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeArrows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0209 12.4646H28.0209V6.4646",
    stroke: "#6300FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22183 8.22183C9.24328 7.20038 10.4559 6.39013 11.7905 5.83733C13.1251 5.28452 14.5555 5 16 5C17.4445 5 18.8749 5.28452 20.2095 5.83733C21.5441 6.39013 22.7567 7.20038 23.7782 8.22183L28.0208 12.4645",
    stroke: "#6300FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97913 19.5354H3.97913V25.5354",
    stroke: "#6300FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7782 23.7783C22.7567 24.7997 21.5441 25.61 20.2095 26.1628C18.8749 26.7156 17.4445 27.0001 16 27.0001C14.5555 27.0001 13.1251 26.7156 11.7905 26.1628C10.4559 25.61 9.24327 24.7997 8.22183 23.7783L3.97919 19.5356",
    stroke: "#6300FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeArrows);
export default __webpack_public_path__ + "v10/media/changeArrows.f3eb8e03fc60260abc262b870d8fec92.svg";
export { ForwardRef as ReactComponent };